import { Link, useSearchParams } from 'react-router-dom';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';
import { AuthService } from '../services/auth';
import { PlatformCheckoutBrand } from '../components/auth/PlatformCheckoutBrand';
import { PlatformCheckoutShell } from '../components/auth/PlatformCheckoutShell';

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl') ?? undefined;

  const loginPath = returnUrl
    ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
    : '/login';

  const handleForgotSubmit = async (email: string) => {
    const continueUrl = `${window.location.origin}/reset-password?email=${encodeURIComponent(email)}${
      returnUrl ? `&returnUrl=${encodeURIComponent(returnUrl)}` : ''
    }`;
    await AuthService.requestPasswordResetEmail(email, continueUrl);
  };

  const left = (
    <>
      <PlatformCheckoutBrand className="mb-6" variant="icon" />
      <h1 className="mb-2 text-xl font-bold text-gray-900 dark:text-white sm:text-2xl">
        Reset your password
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-400 sm:text-base">
        Enter the email on your account and we&apos;ll send a secure reset link.
      </p>
      <p className="mt-6 text-sm text-gray-500 dark:text-gray-500">
        Remember your password?{' '}
        <Link to={loginPath} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          Back to sign in
        </Link>
      </p>
    </>
  );

  return (
    <PlatformCheckoutShell asideVariant="onboarding" left={left}>
      <div className="mx-auto w-full max-w-md lg:mx-0 lg:ml-10 lg:max-w-lg">
        <ForgotPasswordForm loginPath={loginPath} onSubmit={handleForgotSubmit} />
      </div>
    </PlatformCheckoutShell>
  );
}
